export default "__VITE_ASSET__lWbuH3Dv__"